import { createFeatureSelector, createSelector } from '@ngrx/store';

import { SizesLockerFactory } from 'src/app/retail/size-selector/size-factory/Isize-factory';
import { IAmountSpaces } from 'src/app/shared/interfaces/IAmountSpaces';
import { IGroupBySpaceSize } from 'src/app/shared/interfaces/IHDspace';
import { SPACE_STATES } from 'src/app/shared/utils/constants';

import { SpacesState } from './spaces.reducer';

export const selectSpacesState = createFeatureSelector<SpacesState>('spaces');

export const selectSpaces = createSelector(selectSpacesState, (state) => state.spaces);

export const selectSupportedSizes = createSelector(selectSpaces, (spaces) =>
  Array.from(new Set(spaces.map((s) => s.hardwareInfo?.size).filter(Boolean))).sort()
);

export const selectSpacesGroupedBySize = createSelector(selectSpaces, (spaces) =>
  spaces.reduce((acc, space) => {
    const size = space.hardwareInfo?.size;
    if (!size) return acc;

    acc[size] ??= [];
    acc[size].push({ value: space });
    return acc;
  }, {} as Record<number, IGroupBySpaceSize[]>)
);

export const selectAvailableSpacesBySize = createSelector(
  selectSupportedSizes,
  selectSpacesGroupedBySize,
  (supportedSizes, grouped) => {
    const factory = new SizesLockerFactory(grouped);

    return supportedSizes.reduce((acc, size) => {
      acc[size] = factory.createSize(size);
      return acc;
    }, {} as Record<number, IAmountSpaces>);
  }
);

export const selectAvailableSpacesCount = createSelector(
  selectSpaces,
  (spaces) =>
    spaces.filter(
      (space) =>
        space.state.presence === SPACE_STATES.UNFILL &&
        space.state.selectable === SPACE_STATES.AVAILABLE &&
        space.state.secure === SPACE_STATES.CLOSE
    ).length
);

export const isSizeSelectionAvailable = createSelector(
  selectAvailableSpacesBySize,
  (sizes: Record<number, IAmountSpaces>) =>
    Object.values(sizes).filter((size) => size.spaces.length > 0).length > 1
);
